module.exports = __webpack_public_path__ + "62f88d6900885cd7fc7ff2247e129465.png";